// extracted by mini-css-extract-plugin
module.exports = {"dashboardContainer":"ClientDashboard_dashboardContainer__1E3D1","productContainer":"ClientDashboard_productContainer__1FHL1","tileBoard":"ClientDashboard_tileBoard__3JvvI"};